import styled from 'styled-components';

export default styled.div`
    text-align: center;
    margin: 12px 0;
    font-size: 0.8rem;
`;



// WEBPACK FOOTER //
// ./src/SharedComponents/AttributionContainer.tsx